import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

export const AuthGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Em modo mock (ambiente local sem Keycloak), usa o /api/auth/info interceptado pelo MSW.
  // O token OAuth não existe, mas os dados do usuário são carregados via mock.
  if (environment.useMocks) {
    if (!authService.getUserInfo()) {
      await authService.loadUserData();
    }
    return true;
  }

  if (authService.isAuthenticated()) {
    return true;
  }

  router.navigate(['login']);
  return false;
};
